const PostTypeGroup = Object.freeze({
  ORIGINAL: 'Original',
  REPLIES: 'Replies',
  REPOSTS: 'Reposts',
  DISPLAY_COMMENTS: 'DisplayComments'
})
export default PostTypeGroup
export type PostTypeGroupStrings = typeof PostTypeGroup[keyof typeof PostTypeGroup]
// RESERVE BELOW
